import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";
import { getStatuses, deleteStatus } from "../api/statusApi";
import { confirmDialog, showError } from "../utils/alert";
import Pagination, { DEFAULT_PER_PAGE } from "../components/Pagination";

export default function StatusesList() {
  const [statuses, setStatuses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage] = useState(DEFAULT_PER_PAGE);
  const [total, setTotal] = useState(0);
  const navigate = useNavigate();

  const loadStatuses = async () => {
    setLoading(true);
    try {
      const res = await getStatuses({ page, per_page: perPage });
      setStatuses(res.data.items);
      setTotal(res.data.total);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadStatuses();
  }, [page, perPage]);

  const handleDelete = async (id) => {
    const confirmed = await confirmDialog({
      text: "Are you sure you want to delete this status?",
    });
    if (!confirmed) return;

    try {
      await deleteStatus(id);
      loadStatuses();
    } catch (err) {
      showError("Failed to delete status");
    }
  };

  return (
    <AdminLayout title="Statuses">
      <div className="card shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="card-title mb-0">Status List</h5>
            <button
              className="btn skedq-accent-btn"
              onClick={() => navigate("/statuses/new")}
            >
              Add New Status
            </button>
          </div>
          <div className="table-responsive">
            <table className="table table-striped table-hover align-middle mb-0">
              <thead>
                <tr>
                  <th style={{ width: "80px" }}>Sr No.</th>
                  <th>Name</th>
                  <th style={{ width: "160px" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading && (
                  <tr>
                    <td colSpan="3" className="text-center">
                      Loading...
                    </td>
                  </tr>
                )}
                {!loading && statuses.length === 0 && (
                  <tr>
                    <td colSpan="3" className="text-center text-muted">
                      No statuses found.
                    </td>
                  </tr>
                )}
                {!loading &&
                  statuses.map((s, index) => (
                    <tr key={s.id}>
                      <td>{(page - 1) * perPage + index + 1}</td>
                      <td>{s.name}</td>
                      <td>
                        <div className="btn-group btn-group-sm" role="group">
                          <button
                            type="button"
                            className="btn btn-outline-primary"
                            onClick={() => navigate(`/statuses/edit/${s.id}`)}
                          >
                            Edit
                          </button>
                          <button
                            type="button"
                            className="btn btn-outline-danger"
                            onClick={() => handleDelete(s.id)}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <Pagination
            page={page}
            total={total}
            perPage={perPage}
            onPageChange={setPage}
          />
        </div>
      </div>
    </AdminLayout>
  );
}
